import { defineStore } from 'pinia'

const STORAGE_KEY = 'filters:v1'

export const useFilterStore = defineStore('filter', {
  state: () => ({
    country_id: '',
    region_id: '',
    city_id: '',
    district_id: '',
    category: '',
    type: '',
    subcategory: '',
    purpose: '',
    catalog_id: ''
  }),

  actions: {
    hydrate() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (raw) Object.assign(this, JSON.parse(raw))
      } catch (_) { }
    },

    persist() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        country_id: this.country_id,
        region_id: this.region_id,
        city_id: this.city_id,
        district_id: this.district_id,
        category: this.category,
        type: this.type,
        subcategory: this.subcategory,
        purpose: this.purpose,
        catalog_id: this.catalog_id
      }))
    },

    setFilters(payload = {}) {
      Object.assign(this, payload)
      this.persist()
    },

    reset() {
      this.setFilters({
        country_id: '',
        region_id: '',
        city_id: '',
        district_id: '',
        category: '',
        type: '',
        subcategory: '',
        purpose: '',
        catalog_id: ''
      })
    }
  }
})
